module.exports = __webpack_public_path__ + "static/media/icone-azapfy-branco.5130ecb2.png";